<template>
  <Drawer class="manufacturerInfoDrawer_box" :title="manufacturerInfoTitle" width="800"
    v-model="manufacturerInfoModal" :mask-closable="false" :closable="true"
    @on-visible-change="manufacturerInfoChange" :before-close="handleBeforeClose">
    <Form ref="manufacturerInfoForm" :model="manufacturerInfoForm"
      :rules="ruleValidate" :label-width="labelWidth" @submit.native.prevent>
      <!--制造商信息-->
      <Card :bordered="false" dis-hover>
        <template #title>
          <span class="title_box">{{ $t('key1005562') }}</span>
        </template>
        <h3 class="color-666 mb12">{{ $t('key1005563') }}</h3>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1005556')" prop="name" :label-width="230">
              <Input clearable class="width_350" v-model.trim="manufacturerInfoForm.name" :placeholder="$t('key1000324')"></Input>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1005557')" prop="countryCode" :label-width="200">
              <Select class="width_350" v-model="manufacturerInfoForm.countryCode" transfer filterable @on-change="twoCodeChange">
                <Option v-for="item in countryList" :value="item.twoCode" :key="item.twoCode">{{ item.name }}</Option>
              </Select>
            </Form-item>
          </Col>
          <template v-if="manufacturerInfoForm.countryCode">
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1001162')" prop="state">
                <Input class="width_350" :placeholder="$t('key1001163')" clearable v-model.trim="manufacturerInfoForm.state"></Input>
              </Form-item>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1001164')" prop="city">
                <Input class="width_350" :placeholder="$t('key1001165')" clearable v-model.trim="manufacturerInfoForm.city"></Input>
              </Form-item>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1001168')" prop="address">
                <Input class="width_350" type="textarea" :maxlength="500" :placeholder="$t('key1005558')"
                  :autosize="{ minRows: 4, maxRows: 6}" v-model.trim="manufacturerInfoForm.address">
                </Input>
              </Form-item>
            </Col>
          </template>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1001242')" prop="postalCode">
              <Input clearable class="width_350" v-model.trim="manufacturerInfoForm.postalCode" :placeholder="$t('key1000324')"></Input>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1005559')" prop="phone">
              <div class="flex align-items width_350">
                <Select v-model="manufacturerInfoForm.zipCode" filterable transfer style="width: 140px; margin-right: 12px;">
                  <Option v-for="(item, index) in countryList" :value="item.areaCode" :key="index">{{ item.areaCodeName }}</Option>
                </Select>
                <Input :placeholder="$t('key1000324')" clearable v-model.trim="manufacturerInfoForm.phone" style="flex: 1;"></Input>
              </div>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1005560')" prop="email">
              <Input class="width_350" clearable v-model.trim="manufacturerInfoForm.email" :placeholder="$t('key1000324')"></Input>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1005561')" prop="officialWebsite">
              <Input class="width_350" clearable v-model.trim="manufacturerInfoForm.officialWebsite" :placeholder="$t('key1000324')"></Input>
            </Form-item>
          </Col>
        </Row>
      </Card>
    </Form>
    <div class="drawer_footer">
      <Button class="mr15" type="primary" @click="manufacturerInfoBtn">{{ $t('key1000111') }}</Button>
      <Button @click="cancelBtn">{{ $t('key1000112') }}</Button>
    </div>
  </Drawer>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {commonLocalStorage, getAllCountrysData} from "@/utils/common";

export default {
  name: 'manufacturerInfoDrawer',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      manufacturerInfoModal: false,
      manufacturerInfoTitle: '',
      manufacturerInfoType: null,
      manufacturerInfoForm: {
        address: '',
        city: '',
        countryCode: null,
        email: '',
        name: '',
        officialWebsite: '',
        phone: '',
        postalCode: '',
        state: '',
        zipCode: null
      },
      ruleValidate: {
        name: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005550'), trigger: 'blur'}
        ],
        countryCode: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001030'), trigger: 'change'}
        ],
        address: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005551'), trigger: 'blur'}
        ],
        phone: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005552'), trigger: 'blur'}
        ],
        email: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005553'), trigger: 'blur'}
        ],
        postalCode: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005554'), trigger: 'blur'}
        ]
      },
      countryList: [],
      ymsManufacturerInfoId: null,
    };
  },
  computed: {},
  methods: {
    // 初始化数据
    initManufacturerInfoData(type, details) {
      getAllCountrysData('en').then((countryData) => {
        this.countryList = countryData;
        this.$nextTick(() => {
          this.resetData();
        });
        this.manufacturerInfoTitle = type === 'add' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005555') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002184');
        this.manufacturerInfoType = type;
        if (type === 'edit') {
          this.ymsManufacturerInfoId = details.ymsManufacturerInfoId;
          this.getManufacturerDetails(details.ymsManufacturerInfoId);
        }
        this.manufacturerInfoModal = true;
      });
    },
    // 获取制造商详情
    getManufacturerDetails(ymsManufacturerInfoId) {
      this.axios.get(api.get_ymsManufacturerInfo + ymsManufacturerInfoId).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            this.twoCodeChange(data.twoCode);
            for (let key in this.manufacturerInfoForm) {
              this.manufacturerInfoForm[key] = data[key];
            }
          }
        }
      });
    },
    // 确定按钮
    manufacturerInfoBtn() {
      this.$refs.manufacturerInfoForm.validate((valid) => {
        if (valid) {
          let query = {
            ...this.manufacturerInfoForm
          };
          if (this.manufacturerInfoType === 'edit') {
            query.ymsManufacturerInfoId = this.ymsManufacturerInfoId;
          }
          let url = this.manufacturerInfoType === 'add' ? api.post_ymsManufacturerInfo_createManufacturer : api.post_ymsManufacturerInfo_updateManufacturer;
          let text = this.manufacturerInfoType === 'add' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001488') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002279');
          this.axios.post(url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              this.manufacturerInfoModal = false;
              this.$Message.success(text);
              this.$emit('updateData', true);
            }
          });
        }
      });
    },
    // 取消按钮
    cancelBtn() {
      this.handleBeforeClose().then(() => {
        this.resetData();
        this.manufacturerInfoModal = false;
      });
    },
    // 重置数据
    resetData() {
      this.$refs['manufacturerInfoForm'].resetFields();
      this.manufacturerInfoForm = {
        address: '',
        city: '',
        countryCode: null,
        email: '',
        name: '',
        officialWebsite: '',
        phone: '',
        postalCode: '',
        state: '',
        zipCode: null
      };
    },
    // 关闭之前的二次弹窗提示确认
    handleBeforeClose() {
      let v = this;
      return new Promise((resolve, reject) => {
        v.$Modal.confirm({
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000701'),
          content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000702'),
          okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000111'),
          cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
          onOk: () => {
            resolve();
          },
          onCancel: () => {
            reject();
          }
        });
      });
    },
    // 选择国家
    twoCodeChange(value) {
      if (value) {
        this.manufacturerInfoForm.zipCode = null;
        this.countryList.map((item) => {
          if (item.twoCode === value) {
            this.manufacturerInfoForm.zipCode = item.areaCode;
          }
        });
      }
    },
    // 监听弹窗
    manufacturerInfoChange(value) {
      if (!value) {
        this.ymsManufacturerInfoId = null;
        this.resetData();
        commonLocalStorage.removeItem('autoCreate');
      }
    }
  }
};
</script>

<style lang="less" scoped>
.manufacturerInfoDrawer_box {
  /deep/ .ivu-drawer-body {
    padding: 0 20px;

    .width_350 {
      width: 350px;
    }

    .ivu-card-head {
      padding: 14px 0;
    }

    .ivu-card-body {
      padding: 14px 0;
    }

    .title_box {
      color: #333;
      font-size: 15px;
      font-weight: bold;
      background-color: #fff;
    }
  }

  .drawer_footer {
    width: 800px;
    position: fixed;
    bottom: 0;
    right: 0;
    border-top: 1px solid #e8eaec;
    text-align: left;
    padding: 12px 0 12px 15px;
    background-color: #fff;
    z-index: 100;
  }
}
</style>
